module.exports = __webpack_public_path__ + "static/media/logo.48f99fbf.jpg";